import { getEmailSignaturePreferenceFromCache } from '../cache/emailSignatureCache';

export function isSignatureEnabled(): boolean {
    return getEmailSignaturePreferenceFromCache()?.UseDesktopSignature;
}
